import {
  any,
  compose,
  find,
  last,
  map,
  pick,
  prop,
  propEq,
  propSatisfies,
  sortBy,
  toPairs,
  values,
  zipObj,
} from 'ramda';
import { API_FAILURE, API_REQUEST, API_SUCCESS } from 'iqvia-shared';

import { logError } from '../../Shared/UIEventLogger/UIEventLogger';
import api from '../../Shared/Services/api';

const hasAnyInProgressFetches = any(propEq('type', API_REQUEST));
const fetches = {};
let logged = false;

const getResourceTiming = url => {
  const encodedUrl = encodeURI(decodeURI(url));
  const resources = performance.getEntriesByType('resource');
  try {
    const pickTiming = compose(
      // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
      pick(['fetchStart', 'responseEnd', 'duration']),
      find(propSatisfies(resourceName => resourceName.endsWith(encodedUrl), 'name'))
    );
    return pickTiming(resources);
  } catch (err) {
    logError(err);
  }
};

const convertTimingsToArray = compose(
  map(evt => ({ ...evt, UtcStamp: new Date(evt.UnixStamp).toJSON() })),
  map(zipObj(['Event', 'UnixStamp'])),
  toPairs
);

const checkFetchesInProgress = meta => {
  const { url } = meta;

  // set current fetch to success/failure action
  fetches[url] = meta;

  if (logged) {
    return;
  }

  // if there are no more fetches in progress, report metrics
  if (!hasAnyInProgressFetches(values(fetches))) {
    logged = true;

    const getSortedTimings = compose(
      sortBy(prop('responseEnd')),
      map(({ url }) => ({
        url,
        ...getResourceTiming(url),
      })),
      values
    );

    // report metrics
    const resourceTimings = getSortedTimings(fetches);
    api.postJson('/ClientEvents', {
      name: 'PageReady',
      data: {
        PageRequestId: window.App.requestId || 'dev',
        PagePath: window.location.pathname,
        PageTimings: convertTimingsToArray(performance.timing.toJSON()),
        ResourceTimings: resourceTimings,
        ElapsedMilliseconds: last(resourceTimings).responseEnd,
      },
    });
  } else {
    setTimeout(checkFetchesInProgress, 5000, meta);
  }
};

export default store => next => action => {
  if (!action.meta || !action.meta.apiName || action.meta.apiOptions.skipMetrics) {
    return next(action);
  }

  const {
    meta: { url, type },
  } = action;

  // when we see a fetch_request, start a timer.
  // log timings 5 seconds after last fetch_end event if no other fetches are in progress

  switch (type) {
    case API_REQUEST:
      fetches[url] = action.meta;
      break;
    case API_SUCCESS:
      setTimeout(checkFetchesInProgress, 5000, action.meta);
      break;
    case API_FAILURE:
      break;
    default:
  }

  return next(action);
};

// https://www.html5rocks.com/en/tutorials/webperformance/basics/

// https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API



// WEBPACK FOOTER //
// ./src/Root/RootStore/metricsMiddleware.js